export enum VirtualColId {
  QuickFilterVirtualColumnId = 'searchExpression'
}
